import axios from "axios";
import { url } from "../../env";

export function searchTickers(paramsObject) {
  return axios.get(`${url}analysis/search-primary-tickers/`, {
    params: paramsObject,
    paramsSerializer: (params) => {
      return parseParams(params);
    },
  }); //Api to get the tickers
}

export function searchAllTickers(paramsObject) {
  return axios.get(`${url}analysis/search-tickers/`, {
    params: paramsObject,
    paramsSerializer: (params) => {
      return parseParams(params);
    },
  }); //Api to get the tickers
}

export function getMacroSecondaryMetrics(paramsObject) {
  return axios.get(`${url}analysis/get-macro-metrics/`, {
    params: paramsObject,
    paramsSerializer: (params) => {
      return parseParams(params);
    },
  }); //Api to get the tickers
}

export function getMacroOhlcData(paramsObject) {
  return axios.get(`${url}analysis/macro-dashboards-ohlc/`, {
    params: paramsObject,
    paramsSerializer: (params) => {
      return parseParams(params);
    },
  });
}

// api for fetching docchat
export function getDocchat(paramsObject) {
  return axios.get(`${url}analysis/docchat/`, {
    params: paramsObject,
    paramsSerializer: (params) => {
      return parseParams(params);
    },
  });
}

// api for fetching strategy data
export function getStrategy(paramsObject) {
  return axios.get(`${url}analysis/getstrategy/`, {
    params: paramsObject,
    paramsSerializer: (params) => {
      return parseParams(params);
    },
  });
}

// api for fetching strategy data
export function downloadCsv(paramsObject) {
  return axios.get(`${url}analysis/download-csv/`, {
    params: paramsObject,
    paramsSerializer: (params) => {
      return parseParams(params);
    },
  });
}

// api for fetching getOHLCData data
export function getAllData(paramsObject) {
  return axios.get(`${url}analysis/get-all-data/`, {
    params: paramsObject,
    paramsSerializer: (params) => {
      return parseParams(params);
    },
  });
}

export function getMinMaxDateAllTickers(paramsObject) {
  return axios.get(`${url}analysis/get_min_max_date_all_tickers/`, {
    params: paramsObject,
    paramsSerializer: (params) => {
      return parseParams(params);
    },
  });
}

export function calculateScale(payload) {
  return axios.post(`${url}analysis/calculate-scale/`, payload); 
}

function parseParams(params) {
  const keys = Object.keys(params);
  let options = "";

  keys.forEach((key) => {
    const isParamTypeObject = typeof params[key] === "object";
    const isParamTypeArray = isParamTypeObject && params[key].length >= 0;

    if (!isParamTypeObject) {
      options += `${key}=${params[key]}&`;
    }

    if (isParamTypeObject && isParamTypeArray) {
      params[key].forEach((element) => {
        options += `${key}=${element}&`;
      });
    }
  });

  return options ? options.slice(0, -1) : options;
}
